module.exports = __webpack_public_path__ + "roi.svg";